// Utility function to print a deposit slip ticket
// Optimized for thermal printers (80mm) - BLACK ONLY

export const printDepositTicket = (deposit) => {
  const now = new Date(deposit.created_at);
  const dateStr = now.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const timeStr = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  
  let estimatedDateStr = "";
  if (deposit.expected_return_date || deposit.estimated_date) {
    const estDate = new Date(deposit.expected_return_date || deposit.estimated_date);
    estimatedDateStr = estDate.toLocaleDateString('fr-FR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
  }
  
  // Get articles array (handle both 'items' and 'articles' naming)
  const articles = deposit.items || deposit.articles || [];
  
  // Group articles by category
  const articlesByCategory = {};
  let totalArticles = 0;
  articles.forEach(article => {
    if (!articlesByCategory[article.category]) {
      articlesByCategory[article.category] = [];
    }
    articlesByCategory[article.category].push(article);
    totalArticles += article.quantity;
  });
  
  // Build articles HTML - PURE BLACK
  let articlesHtml = '';
  Object.entries(articlesByCategory).forEach(([category, items]) => {
    articlesHtml += `<div style="margin:6px 0;border-top:2px dashed #000;padding-top:5px;color:#000;">
      <div style="font-weight:900;font-size:12px;text-transform:uppercase;margin-bottom:4px;color:#000;">${category}</div>`;
    items.forEach(item => {
      articlesHtml += `<div style="display:flex;justify-content:space-between;font-size:13px;padding:3px 0;color:#000;font-weight:bold;">
        <span style="color:#000;font-weight:bold;">${item.name}</span>
        <span style="font-weight:900;color:#000;">x${item.quantity}</span>
      </div>`;
    });
    articlesHtml += '</div>';
  });
  
  // Build additional treatments HTML
  let treatmentsHtml = '';
  const treatments = deposit.additional_treatments || [];
  if (treatments.length > 0) {
    treatmentsHtml = `<div style="margin:8px 0;border:2px solid #000;padding:8px;">
      <div style="font-weight:900;font-size:12px;text-align:center;margin-bottom:5px;color:#000;">TRAITEMENTS ADDITIONNELS</div>`;
    treatments.forEach(t => {
      treatmentsHtml += `<div style="display:flex;justify-content:space-between;font-size:12px;padding:2px 0;color:#000;font-weight:bold;">
        <span>${t.name}</span>
        <span>${t.price}€</span>
      </div>`;
    });
    treatmentsHtml += '</div>';
  }
  
  const customerName = deposit.customer_name || `${deposit.first_name || ''} ${deposit.last_name || ''}`.trim() || 'Client';
  const amount = deposit.total_amount || deposit.amount;
  
  const printWindow = window.open('', '_blank');
  printWindow.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Ticket</title>
<style>
@page{size:80mm auto;margin:0}
*{color:#000!important;-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}
body{font-family:'Courier New',Courier,monospace;width:80mm;margin:0 auto;padding:5mm;font-size:13px;line-height:1.3;color:#000;background:#fff;font-weight:bold}
.logo{text-align:center;margin-bottom:8px}
.logo img{max-width:50mm;height:auto;filter:grayscale(100%) contrast(200%) brightness(0.9)}
.ticket-number{text-align:center;font-size:22px;font-weight:900;border:3px solid #000;padding:8px;margin:8px 0;color:#000;background:#fff}
.client{text-align:center;font-size:15px;font-weight:900;margin:8px 0;padding:5px;border:3px solid #000;color:#000;background:#fff}
.info-row{display:flex;justify-content:space-between;font-size:12px;margin:4px 0;color:#000;font-weight:bold}
.separator{border:none;border-top:3px dashed #000;margin:8px 0}
.total{text-align:center;font-size:15px;font-weight:900;margin:8px 0;padding:6px;border:3px solid #000;color:#000;background:#fff}
.amount{text-align:center;font-size:20px;font-weight:900;margin:8px 0;padding:10px;border:4px solid #000;color:#000;background:#fff}
.remarks{margin:8px 0;padding:8px;font-size:12px;border:2px solid #000;color:#000;background:#fff;font-weight:bold}
.estimated-date{text-align:center;margin:8px 0;padding:8px;border:2px dashed #000;font-size:13px;color:#000;background:#fff;font-weight:bold}
.footer{text-align:center;font-size:11px;margin-top:12px;color:#000;font-weight:bold}
span,div,p,strong{color:#000!important;font-weight:bold!important}
@media print{*{color:#000!important}body{width:80mm;margin:0;padding:3mm;color:#000;background:#fff;font-weight:bold}.logo img{filter:grayscale(100%) contrast(200%) brightness(0.9)}}
</style></head><body>
<div class="logo"><img src="/logo-sakura.png" alt="Pressing Sakura"/></div>
${deposit.ticket_number ? `<div class="ticket-number">N° ${deposit.ticket_number}</div>` : ''}
<div class="client">${customerName}</div>
<div class="info-row"><span style="color:#000;font-weight:bold;">Date dépôt:</span><span style="color:#000;font-weight:bold;">${dateStr} ${timeStr}</span></div>
<div class="separator"></div>
<div style="font-weight:900;text-align:center;margin-bottom:5px;color:#000;font-size:13px;">ARTICLES DÉPOSÉS</div>
${articlesHtml}
<div class="separator"></div>
<div class="total">${totalArticles} ARTICLE(S)</div>
${treatmentsHtml}
${amount ? `<div class="amount">TOTAL : ${amount} €</div>` : ''}
${deposit.remarks ? `<div class="remarks"><strong style="color:#000;">REMARQUES:</strong><br>${deposit.remarks}</div>` : ''}
${estimatedDateStr ? `<div class="estimated-date"><strong style="color:#000;">RETRAIT PRÉVU</strong><br>${estimatedDateStr}</div>` : ''}
<div class="footer">Merci de votre confiance !<br>Pressing Sakura</div>
<script>window.onload=function(){window.print();}</script>
</body></html>`);
  printWindow.document.close();
};
